import { render, staticRenderFns } from "./ClientOverview.vue?vue&type=template&id=3d022d28"
import script from "./ClientOverview.vue?vue&type=script&lang=js"
export * from "./ClientOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports